<kilowant-header [isSeller]="true" title="Settings"></kilowant-header>
@if (showOnboardingAcc) {
  <div class="seller info mt-50 mb-3"><b>Welcome {{user.firstName}}</b></div>
}
@if (showOnboardingAcc) {
  <div class="progress-tabs">
    <span [className]="(step==1)?'current':''">1</span>
    <span [className]="(step==2)?'current':''">2</span>
    <span [className]="(step==3)?'current':''">3</span>
  </div>
}
@if (showOnboardingAcc) {
  <form [formGroup]="sellerUserDetailsForm">
    @if (step>0 && hideFirstStep) {
      <div class="wrapperMain seller seller-form">
        <div class="card">
          <div class="left-margin"><span class="step-title">1</span></div>
          <h2>User details</h2>
          <div class="body">
            <div class="row m-0">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                <label class="sellerLabel">First name*</label>
                <input class="form-control" formControlName="firstName">
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <label class="sellerLabel">Last name*</label>
                <input class="form-control" formControlName="lastName">
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                <label class="sellerLabel">Email*</label>
                <input class="form-control" formControlName="email">
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <label class="sellerLabel">Phone Number*</label>
                <input class="form-control" formControlName="phone">
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="ac seller-btn" (click)="addUser(true)">Update</button>
      </div>
    }
    @if (step>1 && hideSecondStep) {
      <div class="wrapperMain seller seller-form">
        <div class="card">
          <div class="left-margin"><span class="step-title">2</span></div>
          <div class="body">
            <h2>Company Details</h2>
            <div class="userSellerInfo mb-3">
              <div class="row m-0">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                      <label class="sellerLabel">Your Associated Company*</label>
                      <select class="CompanyList form-control" (change)="getCompanyName($event)" formControlName="companyList">
                        <!-- <option value="0">Select Company</option> -->
                        @for (seller of sellerList; track seller) {
                          <option  value="{{seller.id}}">{{seller.name}}</option>
                        }
                        <option  value="other">Other</option>
                      </select>
                    </div>
                  </div>
                  @if (otherTextInput) {
                    <p class="my-5"><b>Please select other from the dropdown to add a new company details</b></p>
                    <div class="row m-0">
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel newCompany">Company*</label>
                        <input type="text" class="form-control" formControlName="newCompanyname" id="newCompanyname" [ngClass]="{ 'is-invalid': submitted && f.newCompanyname.errors }">
                        @if (submitted && f.newCompanyname.errors) {
                          <div class="invalid-feedback text-danger p-2 mt-0 customerror">
                            @if (f.newCompanyname.errors.required) {
                              <div>Please, Enter New Company.</div>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel website">Website*</label>
                        <input type="text" class="form-control" formControlName="website">
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel address1">Address Line1*</label>
                        <input type="text" class="form-control" formControlName="address1">
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel address2">Address Line2*</label>
                        <input type="text" class="form-control" formControlName="address2">
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel city">City*</label>
                        <input type="text" class="form-control" formControlName="city">
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel state">State*</label>
                        <select class="CompanyList form-control" (change)="getState($event)" formControlName="state">
                          @for (state of  states; track state) {
                            <option value="{{state.id}}">{{state.name}}</option>
                          }
                        </select>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel postalCode">Postal Code*</label>
                        <input type="text" class="form-control" formControlName="postalCode">
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                        <label class="sellerLabel phoneNumber">Phone Number*</label>
                        <input type="text" class="form-control" formControlName="phoneNumber">
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="seller-btn-border mr-3" (click)="goToBackStep(false)">Back</button>
        <button type="button" class="ac seller-btn" (click)="addCompany(true)">Update</button>
      </div>
    }
    @if (step>2 && hideThirdStep) {
      <div class="wrapperMain seller seller-form">
        <div class="card">
          <div class="body">
            <div class="step">
              <div class="title">3</div>
              <div class="body1">
                <div class="info"><b>Utility Served</b></div>
              </div>
            </div>
            <div class="userSellerInfo mb-3">
              <div class="row m-0">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pb-3">
                  <label class="sellerLabel">Your Associated Company</label>
                  <input type="text" class="form-control" value="firstVal" formControlName="yourCompanyName" readonly>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <label>Utility</label>
                  <ng-multiselect-dropdown formControlName="utility" [placeholder]="'select utilities'" [settings]="dropdownSettings" [data]="utilities" [(ngModel)]="selectedItems"></ng-multiselect-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="seller-btn-border mr-3" (click)="goToBackStep2(false)">Back</button>
        <button type="button" class="ac seller-btn" (click)="submitSellerForm()">Update</button>
      </div>
    }
  </form>
}
@if (!showOnboardingAcc) {
  <div class="wrapperMain">
    <mat-tab-group dynamicHeight mat-align-tabs="start" #tabs>
      <mat-tab label="Profile Info">
        <form>
          <div class="form">
            <div class="card">
              <div class="body">
                <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, user.firstName)" placeholder="First name" [(ngModel)]="user.firstName" />
                @if (getVisibilityForLabel(user.firstName)) {
                  <div class="placeholder">First name</div>
                }
                <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, user.firstName)" placeholder="Last name" [(ngModel)]="user.lastName" />
                @if (getVisibilityForLabel(user.lastName)) {
                  <div class="placeholder">Last name</div>
                }
                <input type="text" name="Email" [class]="getClassesForInput('Email', true, user.email)" placeholder="Email" [(ngModel)]="user.email" readonly="true" />
                @if (getVisibilityForLabel(user.email)) {
                  <div class="placeholder">Email</div>
                }
                <input type="text" name="Phone"
                  [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+(focusedField()=='Phone')?'1':''))"
                  (input)="resetError('Phone')"
                  placeholder="Phone"
                  [dropSpecialCharacters]="false"
                  [formControl]="currentPhoneNumber"
                  (focus)="focusField('Phone')"
                  mask="(000) 000-0000"
                  [showMaskTyped] = "(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)"
                  />
                  @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                    <div class="placeholder">Phone</div>
                  }
                  @if (errorY().showError()) {
                    <div class="error-block">{{errorY().error}}</div>
                  }
                </div>
              </div>
              <div class="block-buttons under-card">
                <button type="button" (click)="updateProfile()">Update</button>
                <button type="button">Cancel</button>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="Password">
          <div class="form">
            <div class="card">
              <div class="body">
                <input type="password" name="OldPassword" [class]="getClassesForInput('OldPassword', false, old_password)" placeholder="Current password" [(ngModel)]="old_password" />
                @if (getVisibilityForLabel(old_password)) {
                  <div class="placeholder">Current password</div>
                }
                <input type="password" name="Password" [class]="getClassesForInput('Password', false, password)" placeholder="New password" [(ngModel)]="password" />
                @if (getVisibilityForLabel(password)) {
                  <div class="placeholder">New password</div>
                }
                <input type="password" name="Password2" [class]="getClassesForInput('Password2', false, password2)" placeholder="Confirm new password" [(ngModel)]="password2" />
                @if (getVisibilityForLabel(password2)) {
                  <div class="placeholder">Confirm new password</div>
                }
                @if (errorY().showError()) {
                  <div class="error-block">{{errorY().error}}</div>
                }
              </div>
            </div>
            <div class="block-buttons under-card">
              <button type="button" (click)="sendUpdatePasswordForm()">Update</button>
              <button type="button">Cancel</button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Alerts">
          <div class="form">
            <div class="card">
              <div class="body removelable">
                @for (alertInfo of alertsData; track alertInfo; let i = $index) {
                  <div class="account-info-block">
                    <p class="card-block-background" [class]="(viewAlertsCategory[i])?'':'view-closed'">{{alertInfo.key.name}}
                      <a [class]="(viewAlertsCategory[i])?'collapse':'open'"
                      (click)="viewAlertsCategory[i] = !viewAlertsCategory[i]"></a>
                    </p>
                    <ng-container>
                      <div [class]="(viewAlertsCategory[i])?'visible':'hidden'">
                        @for (alert of alertInfo.value; track alert) {
                          <div class="alertbuttonpadding">
                            <div class="d-flex justify-content-between">
                              <p class="pl-0 accountInfoBorder font16">{{alert.key.name}}</p>
                              <label class="alertSwitch">
                                <input type="checkbox" [checked]="positionInSelected(alert.key)>-1" (click)="addRemoveAlert(alert.key, alert.value)" id="{{alert.key.id}}" />
                                <span class="alertSwitchslider alertSwitchround"></span>
                              </label>
                            </div>
                            @if (alert.value.length>0 && positionInSelected(alert.key)>-1) {
                              <div class="pl-2">
                                @for (alertOption of alert.value; track alertOption) {
                                  <div>
                                    <label><input type="radio" [name]="'o_'+alert.key.id" [checked]="selectedAlerts[positionInSelected(alert.key)].alertOption!=null && selectedAlerts[positionInSelected(alert.key)].alertOption!.id==alertOption.id" (click)="selectedAlerts[positionInSelected(alert.key)].alertOption=alertOption" value="{{alertOption.id}}">
                                    &nbsp; {{alertOption.name}}</label>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </ng-container>
                  </div>
                }
              </div>
            </div>
            <div class="block-buttons under-card">
              <button type="button" (click)="setAlerts()">Update</button>
              <button type="button">Cancel</button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
  <div class="form seller"></div>